module.exports = __webpack_public_path__ + "img/whatsapp_logo.50d6310b.png";